import * as React from "react";
import { SVGProps } from "react";
const SvgNewsfeed = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 25h17v-2H11v2Zm0-16h17V7H11v2Zm0 8h17v-2H11v2Zm-7 9h4v-4H4v4Zm0-16h4V6H4v4Zm0 8h4v-4H4v4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNewsfeed;
